// extracted by mini-css-extract-plugin
export default {"section":"RubroPublishWorkSection_section__WEDtS"};